<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorInstance from '../../../../lib/editor/editor';
  import IncrementalBtn from './IncrementalBtn.svelte';
  import AlwanColorPicker from '@/components/alwan-color-picker/AlwanColorPicker.svelte';
  import {getInstance} from '@/services/animation';
  import {templateFontStore} from '../../../../services/animation/font-loader';
  import editorStore from '../../../../lib/editor/editor.store';
  import {tooltip} from '../../../../actions/tippy-action';
  import {template} from 'lodash';
  import {SiteCache} from '../../../../cache/Cache';
  export let target: HTMLElement;
  export let advanced: boolean = false;
  export let colored: boolean = false;
  let t = 0;

  let styles = writable<any>({});
  function loadStyles() {
    if (!target) return;
    styles.set(window.getComputedStyle(target));
  }

  function recomputeTextSizing() {
    const instance = getInstance();
    if (instance) {
      instance.templateLoader.recomputeTemplateMetadata();
      instance.recomputeCaptionTextSize();
    }
  }
  function changeAlignment(align: string) {
    editorInstance.history.addHistory('alignment change');
    target.style.textAlign = align;
    loadStyles();
    recomputeTextSizing();
  }
  function toggleWeight() {
    editorInstance.history.addHistory('weight change');
    target.style.fontWeight = isBold ? 'normal' : 'bold';
    loadStyles();
    recomputeTextSizing();
  }
  function toggleItalic() {
    editorInstance.history.addHistory('font style change');
    target.style.fontStyle = isItalic ? 'normal' : 'italic';
    loadStyles();
    recomputeTextSizing();
  }

  function changeCase() {
    if (isUppercase) {
      editorInstance.history.addHistory('case change');
      target.style.textTransform = 'none';
    } else {
      editorInstance.history.addHistory('case change');
      target.style.textTransform = 'uppercase';
    }
    loadStyles();
    recomputeTextSizing();
  }

  function updateFontSize(e: any) {
    target.style.fontSize = e.detail + 'px';
    loadStyles();
    recomputeTextSizing();
  }
  function updateLineHeight(e: any) {
    target.style.lineHeight = e.detail + 'px';
    loadStyles();
    recomputeTextSizing();
  }
  $: isBold = $styles.fontWeight == 700;
  $: isItalic = $styles.fontStyle == 'italic';
  $: isUppercase = $styles.textTransform == 'uppercase';

  function isAligned(basis: string, alignment: string) {
    return alignment == basis;
  }

  let textColorPreviewElement: HTMLElement;
  let textOutlinePreviewColor: string;

  let textOutlineSize = 0;
  let isTextOutlineThicknessMenuOpen = false;
  let textOutlineThicknessMenuElement: HTMLElement;

  function textOutlineMenuEvent(event: any) {
    if (!textOutlineThicknessMenuElement) return;
    if (textOutlineThicknessMenuElement.contains(event.target)) return;

    window.removeEventListener('click', textOutlineMenuEvent);
    setTimeout(() => {
      isTextOutlineThicknessMenuOpen = false;
    });
  }

  function openTextOutlineMenu(event: any) {
    if (isTextOutlineThicknessMenuOpen) return textOutlineMenuEvent(event);

    isTextOutlineThicknessMenuOpen = true;
    setTimeout(() => {
      window.addEventListener('click', textOutlineMenuEvent);
    });
  }

  function outlineColorChange(e: any) {
    if (typeof e.detail !== 'object') return;
    const color = typeof e.detail.color === 'function' ? e.detail.color() : e.detail.color;
    textOutlinePreviewColor = color;
    if (textOutlineSize === 0) textOutlineSize = 0.1;
    outlineResize(textOutlineSize);
  }

  const textOutlineOptions = {
    none: 0.0,
    thin: 0.04,
    regular: 0.08,
    thick: 0.12
  };

  function outlineResize(newTextOutlineSize: number) {
    if (!textOutlinePreviewColor || textOutlinePreviewColor === '') return;
    if (newTextOutlineSize < 0) return;
    const color = textOutlinePreviewColor;
    target.style.webkitTextStroke = `${newTextOutlineSize}px ${color}`;
    target.style.paintOrder = 'stroke fill';
    // let filter = `drop-shadow(-${newTextOutlineSize}px -${newTextOutlineSize}px 0 ${color}) drop-shadow(-${newTextOutlineSize}px ${newTextOutlineSize}px 0 ${color}) drop-shadow(${newTextOutlineSize}px -${newTextOutlineSize}px 0 ${color}) drop-shadow(${newTextOutlineSize}px ${newTextOutlineSize}px 0 ${color})`;
    // if (newTextOutlineSize >= 1) {
    //   filter += " drop-shadow(rgb(255, 0, 0) -1px -1px 0px) drop-shadow(rgb(255, 0, 0) -1px 1px 0px) drop-shadow(rgb(255, 0, 0) 1px -1px 0px) drop-shadow(rgb(255, 0, 0) 1px 1px 0px) rop-shadow(rgb(255, 0, 0) -1px -1px 0px) drop-shadow(rgb(255, 0, 0) -1px 1px 0px) drop-shadow(rgb(255, 0, 0) 1px -1px 0px) drop-shadow(rgb(255, 0, 0) 1px 1px 0px)"
    // }
    // target.style.filter = filter
  }

  function updateTextOutline() {
    console.log('updateTextOutline', t);
    outlineResize(t * 12);
    editorInstance.history.addHistory('Update Text Outline');
  }

  // $ : {
  //   if (textOutlineSize < textOutlineOptions.none) textOutlineSize = textOutlineOptions.none;
  //   if (textOutlineSize > textOutlineOptions.thick) textOutlineSize = textOutlineOptions.thick;
  //   outlineResize(textOutlineSize);
  // }

  function textColorChange(e: any) {
    if (typeof e.detail !== 'object') return;
    const color = typeof e.detail.color === 'function' ? e.detail.color() : e.detail.color;
    target.style.color = color;
    textColorPreviewElement.style.backgroundColor = color;
    getInstance().templateLoader.colorLoader.readColors();
  }

  let cb: HTMLDivElement;
  let isPrimary = false,
    isSecondary = false;

  function calculateFontFamilySettings() {
    isPrimary = target.classList.contains('primary-font');
    isSecondary = target.classList.contains('secondary-font');
  }

  let changeTextColor: (color: string) => any;
  let changeOutlineColor: (color: string) => any;

  onMount(() => {
    loadStyles();
    if (changeTextColor) {
      changeTextColor(target.style.color);
      textColorPreviewElement.style.backgroundColor = target.style.color;
    }

    if (changeOutlineColor) {
      const textStrokeSplit = target.style.webkitTextStroke.split(' ');
      const targetTextOutlineThickness = parseFloat(
        textStrokeSplit
          .splice(0, 1)
          .filter(c => !isNaN(parseInt(c)) || c === '.')
          .join('')
      );
      const targetTextOutlineColor = textStrokeSplit.join('') || 'white';

      changeOutlineColor(targetTextOutlineColor);
      outlineColorChange({detail: {color: targetTextOutlineColor}});

      textOutlinePreviewColor = targetTextOutlineColor;
      textOutlineSize = isNaN(targetTextOutlineThickness) ? textOutlineOptions.none : targetTextOutlineThickness;
      outlineResize(textOutlineSize);
    }
    calculateFontFamilySettings();
  });

  function changeFontFamily() {
    const type = selectedFont.toLowerCase().replaceAll(' ', '-');
    const index = type == 'primary-font' ? 0 : 1;
    const font = $templateFontStore[index];
    if (font) {
      const targetFontfamily = '"' + font + '"';
      const isUserFont = SiteCache.customUserFonts.find((f: any) => f.label === font);

      editorInstance.history.addHistory('font change');
      target.style.fontFamily = font;
      // target.style.lineHeight = '1.2';
      target.style.letterSpacing = 'normal';
      target.classList.remove('primary-font', 'secondary-font');
      target.classList.add(type);
      target.removeAttribute('data-user-fonturl');
      target.removeAttribute('data-user-fontname');
      target.removeAttribute('data-customfontname');
      target.removeAttribute('data-nameoffontfile');
      if (isUserFont) {
        target.setAttribute('data-user-fonturl', isUserFont.url);
        target.setAttribute('data-user-fontname', isUserFont.label);
      }
      calculateFontFamilySettings();
      loadStyles();
      recomputeTextSizing();
    }
  }

  let selectedFont = target.classList.contains('secondary-font') ? 'Secondary Font' : 'Primary Font';
  // $ : if (selectedFont !== '') changeFontFamily();

  let pFont: any;
  let sFont: any;
  const unsubscribe = templateFontStore.subscribe(store => {
    if (store && store.length) {
      if (pFont) pFont._tippy.setContent(store[0]);
      if (sFont) sFont._tippy.setContent(store[1]);
    }
  });

  onDestroy(unsubscribe);
</script>

{#if $templateFontStore && $templateFontStore.length == 2}
  {#if advanced}
    <div class="flex justify-between gap-2 pb-4">
      <div class="grid">
        <div class="mb-1 text-xs">Font</div>
        <select
          class="rounded-lg border border-gray-300 bg-white px-2 py-2 text-sm"
          bind:value={selectedFont}
          on:change={changeFontFamily}
        >
          <option selected>Primary Font</option>
          {#if $templateFontStore[1] !== ''}
            <option>Secondary Font</option>
          {/if}
        </select>
      </div>
      <IncrementalBtn title="Font Size" value={Number.parseInt($styles.fontSize)} on:update={updateFontSize} />
      <IncrementalBtn
        title="Line height"
        align="left"
        value={Number.parseInt($styles.lineHeight)}
        on:update={updateLineHeight}
      />
    </div>
  {:else}
    <div class="flex gap-2">
      <div class="mb-1 flex items-center text-xs">Font</div>
      <select
        class="ml-auto rounded-lg border border-gray-300 bg-white px-2 py-2 text-sm"
        bind:value={selectedFont}
        on:change={changeFontFamily}
      >
        <option selected>Primary Font</option>
        <option>Secondary Font</option>
      </select>
    </div>
  {/if}
  <hr />
{/if}
<div class="flex w-full items-center gap-2 {advanced ? 'mt-4' : ''}  ">
  <div class="flex gap-1">
    <div class="formatterBtn centerItem" class:active={isBold} on:click={() => toggleWeight()}>
      <i class="fa fa-bold" />
    </div>
    <div class="formatterBtn centerItem" class:active={isItalic} on:click={() => toggleItalic()}>
      <i class="fa fa-italic" />
    </div>
    <div class="formatterBtn centerItem" class:active={isUppercase} on:click={() => changeCase()}>
      <i class="fa-solid fa-font-case" />
    </div>
    {#if advanced || colored}
      <div class="colorBlock">
        <AlwanColorPicker
          bind:changeColor={changeTextColor}
          enableOutlinePicker={true}
          colorDefault={$styles.color}
          on:change-color={textColorChange}
        >
          <!-- <i class="fa-solid fa-a"></i> -->
          <div class="h-full" bind:this={textColorPreviewElement}></div>
        </AlwanColorPicker>
      </div>
    {/if}
  </div>

  <div class="ml-auto block">
    <div class="flex gap-1">
      <div
        class="formatterBtn centerItem"
        class:active={isAligned($styles.textAlign, 'left')}
        on:click={() => changeAlignment('left')}
      >
        <i class="fa fa-align-left" />
      </div>
      <div
        class="formatterBtn centerItem"
        class:active={isAligned($styles.textAlign, 'center')}
        on:click={() => changeAlignment('center')}
      >
        <i class="fa fa-align-center" />
      </div>
      <div
        class="formatterBtn centerItem"
        class:active={isAligned($styles.textAlign, 'right')}
        on:click={() => changeAlignment('right')}
      >
        <i class="fa fa-align-right" />
      </div>
    </div>
  </div>

  <div class="colorBlock ml-auto">
    <AlwanColorPicker
      bind:changeColor={changeOutlineColor}
      colorDefault={$styles.color}
      on:change-color={outlineColorChange}
    >
      <div class="flex h-full w-full items-center justify-center bg-white">
        <svg
          class="drops-hadow-md"
          width="18"
          height="24"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="path-1-outside-1_767_91"
            maskUnits="userSpaceOnUse"
            x="-3.8147e-06"
            y="1.14441e-05"
            width="17"
            height="17"
            fill="black"
          >
            <rect fill="white" x="-3.8147e-06" y="1.14441e-05" width="17" height="17" />
            <path
              d="M8.90163 2.54848C8.82455 2.38449 8.70238 2.24584 8.5494 2.14871C8.39643 2.05159 8.21897 2.00001 8.03777 2.00001C7.85657 2.00001 7.67911 2.05159 7.52613 2.14871C7.37316 2.24584 7.25099 2.38449 7.17391 2.54848L2.083 13.3667C1.98108 13.5948 1.9727 13.8538 2.05964 14.0881C2.14657 14.3224 2.32191 14.5132 2.54798 14.6196C2.77406 14.726 3.03286 14.7396 3.2688 14.6573C3.50475 14.575 3.69903 14.4035 3.80993 14.1796L5.05004 11.5459H11.0255L12.2648 14.1796C12.3726 14.4087 12.567 14.5856 12.8053 14.6714C13.0435 14.7572 13.306 14.7448 13.5352 14.637C13.7643 14.5292 13.9412 14.3348 14.0269 14.0966C14.1127 13.8583 14.1003 13.5958 13.9925 13.3667L8.90163 2.54848ZM5.94891 9.63678L8.03777 5.19655L10.1274 9.63678H5.94891Z"
            />
          </mask>
          <path
            d="M8.90163 2.54848C8.82455 2.38449 8.70238 2.24584 8.5494 2.14871C8.39643 2.05159 8.21897 2.00001 8.03777 2.00001C7.85657 2.00001 7.67911 2.05159 7.52613 2.14871C7.37316 2.24584 7.25099 2.38449 7.17391 2.54848L2.083 13.3667C1.98108 13.5948 1.9727 13.8538 2.05964 14.0881C2.14657 14.3224 2.32191 14.5132 2.54798 14.6196C2.77406 14.726 3.03286 14.7396 3.2688 14.6573C3.50475 14.575 3.69903 14.4035 3.80993 14.1796L5.05004 11.5459H11.0255L12.2648 14.1796C12.3726 14.4087 12.567 14.5856 12.8053 14.6714C13.0435 14.7572 13.306 14.7448 13.5352 14.637C13.7643 14.5292 13.9412 14.3348 14.0269 14.0966C14.1127 13.8583 14.1003 13.5958 13.9925 13.3667L8.90163 2.54848ZM5.94891 9.63678L8.03777 5.19655L10.1274 9.63678H5.94891Z"
            fill="white"
          />
          <path
            d="M8.90163 2.54848L7.09163 3.39931L7.092 3.40008L8.90163 2.54848ZM7.17391 2.54848L8.98354 3.40008L8.98391 3.39931L7.17391 2.54848ZM2.083 13.3667L0.273359 12.5151L0.264952 12.5329L0.2569 12.551L2.083 13.3667ZM3.80993 14.1796L5.60217 15.0672L5.61095 15.0495L5.61938 15.0316L3.80993 14.1796ZM5.05004 11.5459V9.54587H3.78114L3.24059 10.6939L5.05004 11.5459ZM11.0255 11.5459L12.8352 10.6943L12.2947 9.54587H11.0255V11.5459ZM12.2648 14.1796L14.0745 13.3281L14.0745 13.3281L12.2648 14.1796ZM13.9925 13.3667L15.8022 12.5152L15.8022 12.5151L13.9925 13.3667ZM5.94891 9.63678L4.13917 8.7854L2.79776 11.6368H5.94891V9.63678ZM8.03777 5.19655L9.84738 4.34491L8.03743 0.499003L6.22803 4.34518L8.03777 5.19655ZM10.1274 9.63678V11.6368H13.2791L11.937 8.78514L10.1274 9.63678ZM10.7116 1.69766C10.473 1.19008 10.0949 0.760894 9.6214 0.460274L7.47741 3.83715C7.30987 3.73078 7.17606 3.57891 7.09163 3.39931L10.7116 1.69766ZM9.6214 0.460274C9.14791 0.159653 8.59863 1.14441e-05 8.03777 1.14441e-05V4.00001C7.83931 4.00001 7.64495 3.94352 7.47741 3.83715L9.6214 0.460274ZM8.03777 1.14441e-05C7.4769 1.14441e-05 6.92763 0.159653 6.45414 0.460274L8.59813 3.83715C8.43059 3.94352 8.23623 4.00001 8.03777 4.00001V1.14441e-05ZM6.45414 0.460274C5.98065 0.760894 5.6025 1.19008 5.36391 1.69766L8.98391 3.39931C8.89948 3.57891 8.76567 3.73078 8.59813 3.83715L6.45414 0.460274ZM5.36427 1.69689L0.273359 12.5151L3.89263 14.2183L8.98354 3.40008L5.36427 1.69689ZM0.2569 12.551C-0.058543 13.2571 -0.0845037 14.0588 0.184593 14.7839L3.93468 13.3922C4.0299 13.6488 4.02071 13.9325 3.90909 14.1824L0.2569 12.551ZM0.184593 14.7839C0.453689 15.509 0.996384 16.0997 1.69615 16.4291L3.39982 12.8101C3.64743 12.9267 3.83946 13.1357 3.93468 13.3922L0.184593 14.7839ZM1.69615 16.4291C2.39592 16.7586 3.19695 16.8004 3.92726 16.5458L2.61035 12.7688C2.86876 12.6787 3.15221 12.6935 3.39982 12.8101L1.69615 16.4291ZM3.92726 16.5458C4.65756 16.2912 5.25891 15.7603 5.60217 15.0672L2.01769 13.292C2.13915 13.0467 2.35193 12.8589 2.61035 12.7688L3.92726 16.5458ZM5.61938 15.0316L6.85949 12.3979L3.24059 10.6939L2.00048 13.3276L5.61938 15.0316ZM5.05004 13.5459H11.0255V9.54587H5.05004V13.5459ZM9.21583 12.3974L10.4552 15.0312L14.0745 13.3281L12.8352 10.6943L9.21583 12.3974ZM10.4551 15.0311C10.7888 15.7402 11.3904 16.2877 12.1277 16.5532L13.4828 12.7897C13.7436 12.8836 13.9565 13.0773 14.0745 13.3281L10.4551 15.0311ZM12.1277 16.5532C12.865 16.8186 13.6776 16.7803 14.3867 16.4467L12.6836 12.8273C12.9345 12.7093 13.2219 12.6958 13.4828 12.7897L12.1277 16.5532ZM14.3867 16.4467C15.0957 16.113 15.6432 15.5114 15.9087 14.7741L12.1452 13.419C12.2391 13.1582 12.4328 12.9454 12.6836 12.8273L14.3867 16.4467ZM15.9087 14.7741C16.1742 14.0368 16.1359 13.2242 15.8022 12.5152L12.1829 14.2182C12.0648 13.9673 12.0513 13.6799 12.1452 13.419L15.9087 14.7741ZM15.8022 12.5151L10.7113 1.69689L7.092 3.40008L12.1829 14.2183L15.8022 12.5151ZM7.75865 10.4882L9.84751 6.04793L6.22803 4.34518L4.13917 8.7854L7.75865 10.4882ZM6.22815 6.04819L8.31781 10.4884L11.937 8.78514L9.84738 4.34491L6.22815 6.04819ZM10.1274 7.63678H5.94891V11.6368H10.1274V7.63678Z"
            fill={textOutlinePreviewColor}
            mask="url(#path-1-outside-1_767_91)"
          />
        </svg>
      </div>
    </AlwanColorPicker>
  </div>
  <div class="">
    <button class="formatterBtn centerItem relative" on:click={openTextOutlineMenu}>
      <svg width="18" height="24" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.925 2.8C1.78576 2.8 1.65223 2.85531 1.55377 2.95377C1.45531 3.05222 1.4 3.18576 1.4 3.325C1.4 3.46424 1.45531 3.59777 1.55377 3.69623C1.65223 3.79469 1.78576 3.85 1.925 3.85H12.075C12.2142 3.85 12.3478 3.79469 12.4462 3.69623C12.5447 3.59777 12.6 3.46424 12.6 3.325C12.6 3.18576 12.5447 3.05222 12.4462 2.95377C12.3478 2.85531 12.2142 2.8 12.075 2.8H1.925ZM1.4 6.475C1.4 5.992 1.792 5.6 2.275 5.6H11.725C11.9571 5.6 12.1796 5.69219 12.3437 5.85628C12.5078 6.02038 12.6 6.24293 12.6 6.475C12.6 6.70706 12.5078 6.92962 12.3437 7.09372C12.1796 7.25781 11.9571 7.35 11.725 7.35H2.275C1.792 7.35 1.4 6.958 1.4 6.475ZM1.4 10.325C1.4 9.6488 1.9488 9.1 2.625 9.1H11.375C11.6999 9.1 12.0115 9.22906 12.2412 9.45879C12.4709 9.68853 12.6 10.0001 12.6 10.325C12.6 10.6499 12.4709 10.9615 12.2412 11.1912C12.0115 11.4209 11.6999 11.55 11.375 11.55H2.625C2.30011 11.55 1.98853 11.4209 1.75879 11.1912C1.52906 10.9615 1.4 10.6499 1.4 10.325Z"
          fill="black"
        />
      </svg>
      {#if isTextOutlineThicknessMenuOpen}
        <div
          class="range absolute -bottom-10 -right-2 z-50 flex rounded-md px-2 py-4"
          on:click|stopPropagation
          on:keypress|stopPropagation
        >
          <input
            type="range"
            style={`background:linear-gradient(to right, #E24D72 ${t * 100}%, #ccc ${t * 100}%)`}
            min="0"
            max="1"
            step="0.01"
            bind:value={t}
            on:input={updateTextOutline}
          />
        </div>
        <!-- <div bind:this={textOutlineThicknessMenuElement} class="absolute right-0 w-20 mt-2 z-40 bg-white shadow overflow-x-hidden border border-gray-200 rounded-md">
        <div class="grid">
          <button class="{ textOutlineSize === 0 ? 'bg-zinc-100' : ''}" on:click={() => textOutlineSize = 0}>
            <i class="fa-light fa-horizontal-rule opacity-0"></i>
          </button>
          <button class="{ textOutlineSize === textOutlineOptions.thin ? 'bg-zinc-100' : ''}" on:click={() => textOutlineSize = textOutlineOptions.thin}>
            <i class="fa-light fa-horizontal-rule"></i>
          </button>
          <button class="{ textOutlineSize === textOutlineOptions.regular ? 'bg-zinc-100' : ''}" on:click={() => textOutlineSize = textOutlineOptions.regular}>
            <i class="fa-regular fa-horizontal-rule"></i>
          </button>
          <button class="{ textOutlineSize === textOutlineOptions.thick ? 'bg-zinc-100' : ''}" on:click={() => textOutlineSize = textOutlineOptions.thick}>
            <i class="fa-solid fa-horizontal-rule"></i>
          </button>
        </div>
      </div> -->
      {/if}
    </button>
  </div>
</div>

<style lang="postcss">
  .formatterInput {
    @apply block cursor-pointer rounded-md bg-gray-100 px-2 py-1 hover:bg-gray-300;
  }

  .formatterBtn {
    @apply block cursor-pointer rounded-lg px-2 py-1 hover:bg-gray-100;
  }

  .formatterBtn.active {
    @apply bg-gray-200 hover:bg-gray-200;
  }

  .colorBlock {
    @apply h-7 w-7 cursor-pointer overflow-hidden rounded;
  }

  .fontSelectBtn {
    @apply flex w-1/2 flex-shrink-0 flex-grow-0 cursor-pointer items-center justify-center overflow-hidden text-ellipsis bg-gray-100 py-1 text-center text-xs font-extrabold hover:bg-gray-200;
  }
  .fontLabel {
    @apply flex w-4/5 items-center justify-center truncate;
  }
  .fontSelectBtn.active {
    @apply bg-white text-primary hover:bg-white;
  }

  .range {
    width: 150px;
    background: #fff;
  }

  input[type='range'] {
    /* removing default appearance */
    -webkit-appearance: none;
    appearance: none;
    /* creating a custom design */
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 15px;
    /*  overflow: hidden;  remove this line*/

    /* New additions */
    height: 5px;
    background: #ccc;
  }

  /* Thumb: webkit */
  input[type='range']::-webkit-slider-thumb {
    /* removing default appearance */
    -webkit-appearance: none;
    appearance: none;
    /* creating a custom design */
    height: 15px;
    width: 15px;
    background-color: #ffdde5;
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }

  /* Thumb: Firefox */
  input[type='range']::-moz-range-thumb {
    height: 15px;
    width: 15px;
    background-color: #ffdde5;
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }
</style>
